module.exports = __webpack_public_path__ + "marriot-card-bottom-left@2x.1pi0h-pf.png";